export const LOYALTY_LAST_ACTIVITY_KEY = 'LOYALTY_LAST_ACTIVITY'
export const LOYALTY_INACTIVITY_SHOWN_KEY = 'LOYALTY_INACTIVITY_SHOWN'

// Module-scope session state — lives in memory, resets on logout/page reload.
// Kept here (not in Redux/localStorage) so a new tab always re-fetches from
// getAccountMeta while the same tab never overwrites the frozen value.
const lastActivitySession = {
  initialized: false,
  initializing: false,
}

export const isLastActivitySessionInitialized = () => lastActivitySession.initialized

export const setLastActivitySessionInitialized = () => {
  lastActivitySession.initialized = true
  lastActivitySession.initializing = false
}

export const isLastActivitySessionInitializing = () => lastActivitySession.initializing

export const startLastActivitySessionInit = () => {
  lastActivitySession.initializing = true
}

export const failLastActivitySessionInit = () => {
  lastActivitySession.initializing = false
}

export const resetLastActivitySession = () => {
  lastActivitySession.initialized = false
  lastActivitySession.initializing = false
}
